import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { UserService } from '../services/user.service';
import { map, Observable, take } from 'rxjs';

export const notParentGuard: CanActivateFn = (
  route,
  state
): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const userService = inject(UserService);

  return userService.getUserJourney().pipe(
    map((journey) => {
      return journey?.toLowerCase() !== 'parent'
        ? true
        : router.createUrlTree(['/workspace']);
    }),
    take(1)
  );
};
